<div *ngIf="displayedItems.length==0 || (predicate?.ids && predicate.ids.length==0)" class="list-cartes-empty" i18n="@@NoResultInList">Aucun résultat trouvé dans la liste</div>

<div class="synapi-list-items-container scrollbar scrollbar-hoverable" #container horizontalScroll>
  <div class="synapi-list-items-slider flex flex-column gap-m"  [ngClass]="{'slider-horizontal':scrollHorizontal,'no-overflow':!overflow}" infiniteScroll
           [infiniteScrollDistance]="3"
           [infiniteScrollThrottle]="50"
           [horizontal]="scrollHorizontal"
           [alwaysCallback]="true"
           [infiniteScrollContainer]="container"
           (scrolled)="onListScroll()">
        <ng-container *ngFor="let items of displayedItems">
          <div class="synapi-list-items-slide p-0 grid width-full md-grid-cols-{{col}} gap-m" *ngIf="items?.length">
            <synapi-item *ngFor="let item of items" [item]="item"></synapi-item>
          </div>
        </ng-container>

        <div *ngIf="loading" class="synapi-list-items-slide grid p-0 width-full md-grid-cols-{{col}} gap-m">
          <div class="synapi-item__placeholder" *ngFor="let i of Array.from(Array(size).keys())"></div>
        </div>
      </div>
</div>
